import { ApiCore } from '@/services/api/utils/core.js'
import { handleResponse, handleErrorWithoutRedirect } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'reset-password'
const plural = 'reset-passwords'
const single = 'reset-password'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.create = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}`, payload)
		.then(handleResponse)
		.catch(handleErrorWithoutRedirect);
}


export default api
